"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Spinner = _interopRequireDefault(require("./Spinner"));
exports.default = _Spinner.default;
module.exports = exports["default"];